module.exports = __webpack_public_path__ + "img/photo-shifter-lv2.80691265.png";